'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const index = require('./index-8d6fcb04.js');

const rgStepperHorizontalCss = ":host{display:block}.c-stepper{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;--size:48px;--spacing:16px}.c-stepper__item{-ms-flex:1;flex:1;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;text-align:center;color:#898d8d}.c-stepper__title{font-size:18px;text-transform:uppercase;font-weight:400}.c-stepper__item:before{--size:24px;content:\"\";position:relative;z-index:1;display:block;width:var(--size);height:var(--size);margin:16px auto 0;border:1px solid #898d8d;border-radius:0 50% 50% 50%;-webkit-transform:rotate(85deg);transform:rotate(85deg)}.c-stepper__item:not(:last-child):after{content:\"\";position:relative;top:30px;height:1px;background-color:#898d8d;-ms-flex-order:-1;order:-1;width:calc(100% - var(--size) - calc(var(--spacing) * 2));left:calc(50% + calc(var(--size) / 2 + var(--spacing)))}.c-stepper__item.active{color:#582c83 !important;font-weight:600}.c-stepper__item.active .c-stepper__title{color:#582c83 !important;font-weight:600}.c-stepper__item.active:before{color:#582c83;border:2px solid #582c83}.c-stepper__item.completed{color:#582c83}.c-stepper__item.completed:before{border:1px solid #582c83;color:#582c83;background-color:#582c83}.c-stepper__item.completed:after{background:#582c83}@media (min-width: 320px) and (max-width: 481px){.hide{display:none}}@media (min-width: 1025px){.c-stepper{padding:0px 200px}}@media print{.no-print{display:none}.c-stepper{display:none}}";

const RgStepperHorizontal = class {
    constructor(hostRef) {
        index.registerInstance(this, hostRef);
        this.stepIcon = "drop.svg";
        this.currentStep = 0;
        this.loaded = false;
        this.stepEls = [];
    }
    /** Emitted when the step is clicked. */
    // @Event({ eventName: "rg-click" }) rgClick: EventEmitter;
    async goNextStep() { }
    async oPreviousStep() { }
    currentStepChanged() {
        const stepEl = this.stepEls[this.currentStep];
        stepEl.show();
        const prevStepEl = this.stepEls[this.currentStep - 1];
        prevStepEl.hide();
        window.scrollTo(0, 0);
    }
    dataDidChangeHandler(newVal) {
        this.innerSteps = JSON.parse(newVal);
    }
    async stepClick(step) {
        this.currentStep = step;
    }
    async nextStep() {
        const currentIndex = this.currentStep;
        const newIndex = currentIndex + 1;
        if (newIndex < this.stepEls.length)
            this.currentStep = newIndex;
    }
    async previousStep() {
        this.currentStep = this.currentStep - 1;
    }
    // Lifecycle methods
    connectedCallback() {
        // Assign lightDOM children <rg-stepper-content> to local variable
        var stepperSteps = this.host.querySelectorAll("rg-stepper-horizontal-step");
        if (!!stepperSteps) {
            this.stepEls = Array.from(stepperSteps);
        }
    }
    componentWillLoad() {
        // this.dataDidChangeHandler(this.steps);s
        // wait for child compoents to be loaded first
        // see https://stenciljs.com/docs/component-lifecycle#lifecycle-hierarchy
        // mark the first and last
        this.stepEls[0].first = true;
        this.stepEls[this.stepEls.length - 1].last = true;
        // give each step a number
        this.stepEls.forEach((stepEl, index) => {
            stepEl.step = index;
        });
        // open the first step
        this.stepEls[this.currentStep].show();
        // this.loaded = true;
    }
    componentDidLoad() {
        // console.log("Component has been rendered");
        this.loaded = true;
    }
    render() {
        return (index.h(index.Host, null, index.h("ol", { class: "c-stepper" }, this.stepEls.map((step, i) => {
            const completed = i < this.currentStep;
            return (index.h("li", { class: `c-stepper__item ${this.currentStep === i ? "active" : ""} ${completed ? "completed" : ""}` }, index.h("h3", { class: `c-stepper__title` }, i + 1, ".", index.h("span", { class: "c-steper__title-span hide" }, step.title))));
        })), index.h("slot", null)));
    }
    static get assetsDirs() { return ["assets"]; }
    get host() { return index.getElement(this); }
    static get watchers() { return {
        "currentStep": ["currentStepChanged"],
        "steps": ["dataDidChangeHandler"]
    }; }
};
RgStepperHorizontal.style = rgStepperHorizontalCss;

exports.rg_stepper_horizontal = RgStepperHorizontal;
